/* eslint-disable max-len */
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { type ConsentsAndDeclarationsModuleSpecsFragment } from '../../../../api/fragments/ConsentsAndDeclarationsModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';

export type ConsentsAndDeclarationsModuleEmptyListProps = {
    module: ConsentsAndDeclarationsModuleSpecsFragment;
};

const ConsentsAndDeclarationsModuleEmptyList = ({ module }: ConsentsAndDeclarationsModuleEmptyListProps) => {
    const { t } = useTranslation(['consentsAndDeclarationsModuleDetails']);
    const navigate = useNavigate();

    return (
        <NoItemResult
            extra={
                <Button onClick={() => navigate('/admin/consents/add')} type="primary">
                    {t('consentsAndDeclarationsModuleDetails:emptyList.noData.action')}
                </Button>
            }
            subTitle={t('consentsAndDeclarationsModuleDetails:emptyList.noData.message')}
        />
    );
};

export default ConsentsAndDeclarationsModuleEmptyList;
